// Homes, floors and rooms changed: pages that show them reload.
export const PLACES_CHANGED = "hx-places-changed";

export const placesChanged = () => window.dispatchEvent(new Event(PLACES_CHANGED));

// The API answers a name that's already used with 200 and a message (text for
// a home, { message } for a floor or room) instead of creating it.
export const nameTaken = (response) => {
  const text = typeof response === "string" ? response : response?.message;
  return typeof text === "string" && /exists/i.test(text) ? text : null;
};
